import { render, staticRenderFns } from "./BusinessOrdersListView.vue?vue&type=template&id=361311fe&scoped=true&"
import script from "./BusinessOrdersListView.vue?vue&type=script&lang=ts&"
export * from "./BusinessOrdersListView.vue?vue&type=script&lang=ts&"
import style0 from "./BusinessOrdersListView.vue?vue&type=style&index=0&id=361311fe&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "361311fe",
  null
  
)

export default component.exports